import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e679bb7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center h-full" }
const _hoisted_2 = { class: "modal-content" }

import { ref, PropType } from 'vue'
import { onClickOutside, onKeyStroke } from '@vueuse/core'


const __default__ = {
  inheritAttrs: false
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ModalWrapper',
  props: {
  show: Boolean,
  showLoading: Boolean,

  ignore: {
    type: Array as PropType<string[]>,
    default: () => []
  },

  containerClass: {
    type: String,
    default: ''
  },

  wrapperClass: {
    type: String,
    default: 'bg-gray-900 bg-opacity-80'
  }
},
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const modalRef = ref(null)

onKeyStroke('Escape', () => {
  if (props.show) {
    close()
  }
})

onClickOutside(
  modalRef,
  () => {
    close()
  },
  {
    ignore: ['.modal-content', ...props.ignore]
  }
)

const close = () => {
  emit('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "modal",
    appear: ""
  }, {
    default: _withCtx(() => [
      (__props.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["fixed inset-0 z-50 h-full w-full duration-300 ease-in", __props.wrapperClass])
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", {
                ref_key: "modalRef",
                ref: modalRef,
                class: _normalizeClass(["modal-container overflow-y-hidden", _ctx.$attrs.class])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["max-h-screen sm:max-h-[90vh] overflow-y-auto", __props.containerClass])
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default", {
                      close: close,
                      showLoading: __props.showLoading
                    })
                  ])
                ], 2)
              ], 2)
            ])
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})